package feature.employee.repository

import feature.auth.model.FriendlyProfile
import feature.employee.model.Employee
import feature.employee.model.EmployeeAttendance
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class EmployeeRepository {

    val searchQueryState: MutableStateFlow<String> = MutableStateFlow("")
    val searchQuery: StateFlow<String>
        get() = searchQueryState

    val allEmployeeLiveData: MutableStateFlow<ArrayList<Employee>> = MutableStateFlow(arrayListOf())
    val allEmployee: StateFlow<ArrayList<Employee>>
        get() = allEmployeeLiveData

    val employeeLiveData: MutableStateFlow<Employee> = MutableStateFlow(Employee())
    val employee: StateFlow<Employee>
        get() = employeeLiveData

    val profileLiveData: MutableStateFlow<FriendlyProfile> = MutableStateFlow(FriendlyProfile())
    val profile: StateFlow<FriendlyProfile>
        get() = profileLiveData

    //Attendance
    val employeeAttendanceLiveData: MutableStateFlow<EmployeeAttendance> =
        MutableStateFlow(EmployeeAttendance())
    val employeeAttendanceData: StateFlow<EmployeeAttendance>
        get() = employeeAttendanceLiveData

    val allEmployeeAttendanceLiveData: MutableStateFlow<ArrayList<EmployeeAttendance>> =
        MutableStateFlow(
            arrayListOf()
        )
    val allEmployeeAttendance: StateFlow<ArrayList<EmployeeAttendance>>
        get() = allEmployeeAttendanceLiveData

}